<div class="container">
  <div>
    <ion-row size="12">

      <div *ngIf="chechsetupStatus ||checkdateOrConfirmationNull" style="color: red;" class="m-10 p-20">
        Not Completed Setup
      </div>
    </ion-row>
  </div>
  <div class="cardBox mb-20 p-10">


    <ion-row>
      <ion-col size>

        <div class="phi-flex-wrap-center phi-gap-12">
          <mat-form-field class="w-100 max-w-220 mat-height40 mat-input-style">
            <mat-icon matPrefix>search</mat-icon>
            <input matInput type="search" placeholder="Search" [(ngModel)]="searchTerm" (input)="filterEmployees()">
          </mat-form-field>

          <!-- </ion-col>
      <ion-col size="2" class="mt-20"> -->

          <ng-multiselect-dropdown *ngIf="getLocationList.length>0" [placeholder]="'Select location'"
            [settings]="dropdownSettings" [data]="getLocationList" [(ngModel)]="selectedLocation"
            (onSelect)="onselectLocation()" (onDeSelect)="onDeSelectLocation()"
            (onSelectAll)="selecAlltLocation($event)" (onDeSelectAll)="onDeSelectAllLocation()" class="w-100 max-w-220">
          </ng-multiselect-dropdown>
        </div>
 

      
      </ion-col>
      <ion-col size="auto">


        <!-- <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3"> -->
        <div class="phi-flex-wrap-center phi-gap-12">
          <div *ngIf="checkProbationEmployeeHODmanager">

            <button (click)="changedFromEmployee('view')" class="elcm_Btn fs-14 fs_12ForMobile "
            [style.background-color]="buttonColorName">
            Your Probation Evaluation Form</button>              
          </div>
          <label class="phi-flex phi-gap-6 phi-align-items-center">
            <ion-label class="fs-14 fs_12ForMobile font_regular black_color ">Show</ion-label>
            <mat-form-field class="w-100 max-w-75 mat-height40 mat-input-style">
              <mat-select placeholder="Select" [(ngModel)]="selectedSize" placeholder="Select" (selectionChange)="DislaySelectedRecord($event)">
                
                <mat-option [value]="25">25</mat-option>
                <mat-option [value]="50">50</mat-option>
                <mat-option [value]="75">75</mat-option>
                <mat-option [value]="100">100</mat-option>
              </mat-select>
            </mat-form-field>
            <ion-label class="fs-14 fs_12ForMobile font_regular black_color">entries</ion-label>
          </label>
          <div>
            <span class="ml-5 mr-5 icon-download fs-20 material-icons" (click)="downloadCSV()">download</span>
          </div>
        </div>
        <!-- </div> -->
      </ion-col>

    
    </ion-row>



    <div class="pt-10">
      <ion-row>
        <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
          <div class="table-container">
            <table>

              <thead>
                <tr>

                  <th *ngFor="let item of ProbationTableHeader" class="fs-14 fs_12ForMobile font_bold cl-black">
                    <div class="p-5 verticle-center justify-content-space-between icon-style" style="width: 90px;">
                      {{ item?.label }}

                    </div>
                  </th>
                </tr>
              </thead>

              <tbody>
                <tr *ngFor="let employee of employeesProbationDetails; let i = index">
                  <!-- Sr. No -->
                  <td>{{ i + 1 }}</td>
                  <td>{{ employee.emplCode }}</td>
                  <td>{{ employee.empName }}</td>
                  <td>{{ employee.empDept }}</td>
                  <td>{{ employee.band}}</td>
                  <td>{{ employee.grade }}</td>
                  <td>{{ employee.empCityLocation }}</td>
                  <td>{{ employee.dateOfJoining | date: 'dd-MM-yyyy'}}</td>
                  <td>{{ employee.dateOfConfirmation | date: 'dd-MM-yyyy' }}</td>
                  <td *ngIf="loggedInUserRole!=='HOD' && loggedInUserRole!=='Manager'&&loggedInUserRole!=='Employee'">
                    <mat-form-field class="w-90 mat-height40 mat-input-style" (click)="confirmationpopp(employee)">
                      <mat-select placeholder="select probation " (ngModelChange)="getprobationData(employee)"
                        [(ngModel)]="employee.probationStatus" (selectionChange)="onProbationChange(employee)"
                        [disabled]="(loggedInUserRole=='HOD'||loggedInUserRole=='Manager'||loggedInUserRole=='Employee'||checkdateOrConfirmationNull) && !isEditable(employee) ">
                        <mat-option [value]="'Confirmation'" [disabled]="!confirmationFlag">
                          Confirm
                        </mat-option>
                        <mat-option [value]="'Extension'">
                          Extension
                        </mat-option>

                      </mat-select>
                    </mat-form-field>
                  </td>
                  <td
                    *ngIf="!(loggedInUserRole === 'HR Admin' || loggedInUserRole === 'Admin' || loggedInUserRole === 'Super Admin' || loggedInUserRole === 'PHI Admin' || loggedInUserRole === 'MD')">
                    {{employee.probationStatus}}
                  </td>
                  <td> {{employee.probationExtensionByDay}}</td>
                  <td>
                    <!-- [disabled]="(loggedInUserRole=='HOD'||loggedInUserRole=='Manager')&& !isEditable(employee)" -->
                    <textarea rows="2" cols="4" class="edittextarea" [(ngModel)]="employee.reasonForExtension"
                      [disabled]="!(loggedInUserRole === 'HR Admin' || loggedInUserRole === 'Admin' || loggedInUserRole === 'Super Admin' || loggedInUserRole === 'PHI Admin' || loggedInUserRole === 'MD')"
                      maxlength="255" (ngModelChange)="getprobationData(employee)"
                      [ngModelOptions]="{standalone: true}"></textarea>
                  </td>
                  <td
                    *ngIf="(loggedInUserRole === 'HR Admin' || loggedInUserRole === 'Admin' || loggedInUserRole === 'Super Admin' || loggedInUserRole === 'PHI Admin' || loggedInUserRole === 'MD')">
                    <mat-form-field class="w-90 mat-height40 mat-input-style">
                      <mat-select placeholder="select probation" (ngModelChange)="getprobationData(employee)"
                        [(ngModel)]="employee.changesPostConfirmation"
                        [disabled]="employee.probationStatus !=='Confirmation'">
                        <mat-option [value]="'No_Change'">
                          No Change
                        </mat-option>
                        <mat-option [value]="'Change_Needed'" (click)="onClickOpenChangeNeededPopup(employee.userId)">
                          Change Needed
                        </mat-option>

                      </mat-select>
                    </mat-form-field>
                  </td>
                  <td
                    *ngIf="loggedInUserRole === 'HR Admin' || loggedInUserRole === 'Admin' || loggedInUserRole === 'Super Admin' || loggedInUserRole === 'PHI Admin' || loggedInUserRole === 'MD'">
                    <div class="d-flex align-items-center justify-content-start">
                      <!-- Eye Icon -->
                      <img src="././assets/icon/blueEyeIcon.svg" matTooltip="Recommended By {{employee.recommendedBy}}"
                        class="cp mr-2"
                        [style.visibility]="((loggedInUserRole === 'HR Admin' || loggedInUserRole === 'Admin' || loggedInUserRole === 'Super Admin' || loggedInUserRole === 'PHI Admin' || loggedInUserRole === 'MD') && employee.matchuser) ? 'visible' : 'hidden'"
                        (click)="changedFromHODORManager(employee.userId, employee.recommendedBy, employee.probationCurrentLogUserType,employee)">
                      <mat-icon matTooltip="Preview"  [style.visibility]="((loggedInUserRole === 'HR Admin' || loggedInUserRole === 'Admin' || loggedInUserRole === 'Super Admin' || loggedInUserRole === 'PHI Admin' || loggedInUserRole === 'MD') && employee.matchuser) ? 'visible' : 'hidden'"
                        class="info-bordered-icon phi-align-content-center" style="height: auto;width: auto;"  (click)="previewRating(employee.userId, null, null,employee)">
                        info
                      </mat-icon>
                      <!--  [style.visibility]="(employee.status === 'OFFER_LETTER_SENT' || employee.status === 'APPROVED_APPOINTMENT_LETTER') ? 'visible' : 'hidden'" -->
                      <!-- Save Button - Visible only for HR Admin, Super Admin, PHI Admin, MD -->
                      <button type="button" class="add_btn fs-14 fs_12ForMobile custom-disabled-button mr-2"
                        [ngStyle]="{'background-color': buttonColorName}"
                        [ngClass]="{'disabled-cell': getProbationEmployeeDetails?.emplCode !== employee.emplCode}"
                        *ngIf="loggedInUserRole === 'HR Admin' || loggedInUserRole === 'Admin' || loggedInUserRole === 'Super Admin' || loggedInUserRole === 'PHI Admin' || loggedInUserRole === 'MD'"
                        (click)="SaveProbationData(employee.userId, employee)">
                        Save
                      </button>
                    </div>

                  </td>
                  <!-- <div class="d-flex align-items-center justify-content-start">
                      <img src="././assets/icon/blueEyeIcon.svg" 
                           matTooltip="Recommended By {{employee.recommendedBy}}" 
                           class="cp mr-2"
                           [style.visibility]="((loggedInUserRole === 'HR Admin' || loggedInUserRole == 'Admin' || loggedInUserRole === 'Super Admin' || loggedInUserRole === 'PHI Admin' || loggedInUserRole === 'MD') && employee.matchuser) ? 'visible' : 'hidden'"
                           (click)="changedFromHODORManager(employee.userId,employee.recommendedBy,employee.probationCurrentLogUserType)">
                  
                           <button type="button" class="add_btn fs-14 fs_12ForMobile custom-disabled-button"
                           [ngStyle]="{'background-color': buttonColorName}"
                           [disabled]="employee.probationStatus && !(loggedInUserRole === 'HR Admin' || loggedInUserRole === 'Admin' || loggedInUserRole === 'Super Admin' || loggedInUserRole === 'PHI Admin' || loggedInUserRole === 'MD')"
                           (click)="(loggedInUserRole === 'HR Admin' || loggedInUserRole === 'Admin' || loggedInUserRole === 'Super Admin' || loggedInUserRole === 'PHI Admin' || loggedInUserRole === 'MD') ? SaveProbationData(employee.userId,employee) : changedFromHODORManager(employee.userId, null, null)">
                     {{ (loggedInUserRole === 'HR Admin' || loggedInUserRole === 'Admin' || loggedInUserRole === 'Super Admin' || loggedInUserRole === 'PHI Admin' || loggedInUserRole === 'MD') ? 'Save' : 'Edit By ' + loggedInUserRole }}
                   </button>
                   
                    </div>
                     -->
                  <td
                    *ngIf="loggedInUserRole !== 'HR Admin' && loggedInUserRole !== 'Admin' && loggedInUserRole !== 'Super Admin' && loggedInUserRole !== 'PHI Admin' && loggedInUserRole !== 'MD'">
                    <button type="button" class="add_btn fs-14 fs_12ForMobile custom-disabled-button"
                      [ngStyle]="{'background-color': buttonColorName}"
                      [disabled]="employee.probationStatus && !(loggedInUserRole === 'HR Admin' || loggedInUserRole == 'Admin' || loggedInUserRole === 'Super Admin' || loggedInUserRole === 'PHI Admin' || loggedInUserRole === 'MD')"
                      (click)="changedFromHODORManager(employee.userId, null, null,employee)">
                      Edit By {{ loggedInUserRole }}
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </ion-col>
      </ion-row>
    </div>
  </div>
</div>